//2026/2/4 室内窓LP対応で新規作成　担当：四方
//横幅max表示のスライダー

(function() {
  'use strict';

  const sliders = document.querySelectorAll('[data-peek-slider][data-mode="marquee"]');
  sliders.forEach(initMarquee);

  function initMarquee(root) {
    const track  = root.querySelector('.peek-slider__track');
    const slides = Array.from(root.querySelectorAll('.peek-slider__slide'));
    if (!track || slides.length === 0) return;

    // CSS 変数同期
    const peek = parseInt(root.dataset.peek || '0', 10);
    const gap  = parseInt(root.dataset.gap  || '0', 10);
    root.style.setProperty('--peek', peek + 'px');
    root.style.setProperty('--gap',  gap  + 'px');

    // 1周分を複製して 2周分のリストに
    const fragment = document.createDocumentFragment();
    slides.forEach(s => fragment.appendChild(s.cloneNode(true)));
    track.appendChild(fragment);

    // 幅計測 → 速度設定
    function measureTrackWidth() {
      const rect = track.getBoundingClientRect();
      return rect.width *1.8 ; // 1周分の幅（複製して2周分にしているため）
    }

    function applyMarquee() {
      const oneLoopWidth = measureTrackWidth();
      if (!oneLoopWidth) { requestAnimationFrame(applyMarquee); return; }

      // 速度(px/sec) は data-speed から。なければ 50(px/s)
      const pxPerSec = parseInt(root.dataset.speed || '50', 10);
      const duration = oneLoopWidth / pxPerSec; // 秒
      root.style.setProperty('--marquee-duration', duration + 's');

      // 終点（負方向）に 1周分を指定
      root.style.setProperty('--marquee-end', (-oneLoopWidth) + 'px');

      root.classList.add('peek-slider--marquee');
    }

    // 画像読み込み後に再計算
    const imgs = root.querySelectorAll('.peek-slider__img');
    let pending = imgs.length;
    if (pending === 0) {
      applyMarquee();
    } else {
      imgs.forEach(img => {
        if (img.complete) {
          if (--pending === 0) applyMarquee();
        } else {
          img.addEventListener('load', () => { if (--pending === 0) applyMarquee(); }, { once: true });
        }
      });
    }

    // リサイズで調整
    let t = null;
    window.addEventListener('resize', () => {
      if (!root.classList.contains('peek-slider--marquee')) return;
      clearTimeout(t);
      t = setTimeout(applyMarquee, 120);
    });
  }
})();